// Avery Zweckform 3474 / 24-up A4: 70 x 37 mm, 3 columns x 8 rows, no gaps.
// QR stays 1 inch (GS1 / ISO 18004 consumer-scan size) inside each label.
const PAGE_W = 210;
const PAGE_H = 297;
const QR_MM = 25.4;
const CELL_W = 70;
const CELL_H = 37;
const COLS = 3;
const ROWS = 8;
const LEFT = (PAGE_W - COLS * CELL_W) / 2;
const TOP = (PAGE_H - ROWS * CELL_H) / 2;
const TEXT_MAX = CELL_W - 4;

// jspdf and qrcode load only when a label is previewed or printed.
export async function qrDataUrl(text: string): Promise<string> {
  const { default: QRCode } = await import("qrcode");
  return QRCode.toDataURL(text, {
    margin: 4,
    width: 300,
    errorCorrectionLevel: "M",
  });
}

export async function downloadLabelPdf(
  rows: { value: string; scan_url: string }[],
  filename: string,
): Promise<void> {
  const labels = rows.filter((row) => row.scan_url);
  if (labels.length === 0) return;

  const { jsPDF } = await import("jspdf");
  const pdf = new jsPDF({ unit: "mm", format: "a4" });
  const perPage = COLS * ROWS;

  pdf.setFont("courier", "normal");
  pdf.setFontSize(7);
  pdf.setTextColor(20, 20, 20);

  // One line under the QR; a value too long for the label ends in an ellipsis.
  const fit = (text: string) => {
    if (pdf.getTextWidth(text) <= TEXT_MAX) return text;
    let cut = text;
    while (cut.length > 1 && pdf.getTextWidth(`${cut}…`) > TEXT_MAX) {
      cut = cut.slice(0, -1);
    }
    return `${cut}…`;
  };

  for (let i = 0; i < labels.length; i += 1) {
    if (i > 0 && i % perPage === 0) pdf.addPage();

    const slot = i % perPage;
    const x = LEFT + (slot % COLS) * CELL_W;
    const y = TOP + Math.floor(slot / COLS) * CELL_H;
    const label = labels[i];
    const qrX = x + (CELL_W - QR_MM) / 2;
    const qrY = y + 1.2;

    pdf.addImage(await qrDataUrl(label.scan_url), "PNG", qrX, qrY, QR_MM, QR_MM);
    const text = fit(label.value);
    pdf.textWithLink(text, x + (CELL_W - pdf.getTextWidth(text)) / 2, qrY + QR_MM + 3, {
      url: label.scan_url,
    });
  }

  const safe = filename.replace(/[^\w.-]+/g, "-").replace(/^-|-$/g, "") || "labels";
  pdf.save(`${safe}.pdf`);
}
